import StoriesList from "../../components/Stories/StoriesList/StoriesList.js";
import { getStories } from "../../utils/apiUtils.js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StoryModal from "../../components/Stories/StoryModal/StoryModal.js";
import "./StoriesPage.scss";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

function StoriesPage() {
  const [allStories, setAllStories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useContext(AuthContext);

  const fetchStories = async () => {
    try {
      const { data } = await getStories();
      setAllStories(data);
    } catch (error) {
      console.error("Error fetching stories:", error);
    }
  };

  console.log(allStories);
  useEffect(() => {
    fetchStories();
  }, []);

  // const openModal = () => {
  //   setIsModalOpen(true);
  // };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const addNewStory = (newStory) => {
    setAllStories((prevStories) => [...prevStories, newStory]);
  };

  // Allow to add a story only if the user is logged in.
  const navigate = useNavigate();
  const handleStartHere = () => {
    if (!user) {
      // if not logged in → send to login
      navigate("/login");
      return;
    }

    // if logged in → open story modal
    // StoryModal();
    setIsModalOpen(true);
  };

  return (
    <div>
      <section className="add-story__bkgrd">
        {/* <h3 className="add-story__sub-heading">Welcome to</h3> */}
        <h2 className="add-story__heading">The Grieffiti Wall</h2>
        <h3 className="add-story__sub-heading">
          ...A Safe Space To Share Your Story.
        </h3>

        {/* {user ? (
          <button className="add-story__btn" onClick={openModal}>
            Start Here
          </button>
        ) : (
          <p>Please log in to share your story!</p>
        )} */}

        <button className="add-story__btn" onClick={handleStartHere}>
          Start Here
        </button>
      </section>

      <StoriesList
        allStories={allStories}
        setAllStories={setAllStories}
        user={user}
      />
      <StoryModal
        isOpen={isModalOpen}
        onClose={closeModal}
        addNewStory={addNewStory}
      />
    </div>
  );
}

export default StoriesPage;
